import { SelectOptionTypes } from "../../../components/Input";
import { REPORTS_MIN_TAX_YEAR } from "./constants";

// Current year first, descending to the documented floor. See REPORTS_MIN_TAX_YEAR for
// why the range is a constant rather than fetched.
export const buildTaxYearOptions = (): SelectOptionTypes[] => {
  const currentYear = new Date().getFullYear();
  const options: SelectOptionTypes[] = [];

  for (let year = currentYear; year >= REPORTS_MIN_TAX_YEAR; year--) {
    options.push({ label: String(year), value: String(year) });
  }

  return options;
};
